//The time is displayed in minutes
const ONE_HOUR_MINUTES = 60

export default Object.freeze({
    en: [
        {
            label: '12 hours',
            value: 12 * ONE_HOUR_MINUTES,
        },
        {
            label: '11 hours',
            value: 11 * ONE_HOUR_MINUTES,
        },
        {
            label: '10 hours',
            value: 10 * ONE_HOUR_MINUTES,
        },
        {
            label: '9 hours',
            value: 9 * ONE_HOUR_MINUTES,
        },
        {
            label: '8 hours',
            value: 8 * ONE_HOUR_MINUTES,
        },
        {
            label: '7 hours',
            value: 7 * ONE_HOUR_MINUTES,
        },
        {
            label: '6 hours',
            value: 6 * ONE_HOUR_MINUTES,
        },
        {
            label: '5 hours',
            value: 5 * ONE_HOUR_MINUTES,
        },
        {
            label: '4 hours',
            value: 4 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 hours 30 minutes',
            value: 3.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 hours',
            value: 3 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 hours 45 minutes',
            value: 2.75 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 hours 30 minutes',
            value: 2.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 hours 15 minutes',
            value: 2.25 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 hours',
            value: 2 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 hour 55 minutes',
            value: 115,
        },
        {
            label: '1 hour 50 minutes',
            value: 110,
        },
        {
            label: '1 hour 45 minutes',
            value: 1.75 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 hour 40 minutes',
            value: 100,
        },
        {
            label: '1 hour 35 minutes',
            value: 95,
        },
        {
            label: '1 hour 30 minutes',
            value: 1.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 hour 25 minutes',
            value: 85,
        },
        {
            label: '1 hour 20 minutes',
            value: 80,
        },
        {
            label: '1 hour 15 minutes',
            value: 1.25 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 hour 10 minutes',
            value: 70,
        },
        {
            label: '1 hour 5 minutes',
            value: 65,
        },
        {
            label: '1 hour',
            value: 1 * ONE_HOUR_MINUTES,
        },
        {
            label: '55 minutes',
            value: 55,
        },
        {
            label: '50 minutes',
            value: 50,
        },
        {
            label: '45 minutes',
            value: (3 * ONE_HOUR_MINUTES) / 4,
        },
        {
            label: '40 minutes',
            value: (ONE_HOUR_MINUTES * 2) / 3,
        },
        {
            label: '35 minutes',
            value: 35,
        },
        {
            label: '30 minutes',
            value: ONE_HOUR_MINUTES / 2,
        },
        {
            label: '25 minutes',
            value: ONE_HOUR_MINUTES / 2.4,
        },
        {
            label: '20 minutes',
            value: ONE_HOUR_MINUTES / 3,
        },
        {
            label: '15 minutes',
            value: ONE_HOUR_MINUTES / 4,
        },
        {
            label: '10 minutes',
            value: ONE_HOUR_MINUTES / 6,
        },
        {
            label: '5 minutes',
            value: ONE_HOUR_MINUTES / 12,
        },
        {
            label: '0 minutes',
            value: '0',
        },
    ],
    sr: [
        {
            label: '12 sati',
            value: 12 * ONE_HOUR_MINUTES,
        },
        {
            label: '11 sati',
            value: 11 * ONE_HOUR_MINUTES,
        },
        {
            label: '10 sati',
            value: 10 * ONE_HOUR_MINUTES,
        },
        {
            label: '9 sati',
            value: 9 * ONE_HOUR_MINUTES,
        },
        {
            label: '8 sati',
            value: 8 * ONE_HOUR_MINUTES,
        },
        {
            label: '7 sati',
            value: 7 * ONE_HOUR_MINUTES,
        },
        {
            label: '6 sati',
            value: 6 * ONE_HOUR_MINUTES,
        },
        {
            label: '5 sati',
            value: 5 * ONE_HOUR_MINUTES,
        },
        {
            label: '4 sata',
            value: 4 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 sata 30 minuta',
            value: 3.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 sata',
            value: 3 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 sata 45 minuta',
            value: 2.75 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 sat 30 minuta',
            value: 2.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 sat 15 minuta',
            value: 2.25 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 sata',
            value: 2 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 sat 55 minuta',
            value: 115,
        },
        {
            label: '1 sat 50 minuta',
            value: 110,
        },
        {
            label: '1 sat 45 minuta',
            value: 1.75 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 sat 40 minuta',
            value: 100,
        },
        {
            label: '1 sat 35 minuta',
            value: 95,
        },
        {
            label: '1 sat 30 minuta',
            value: 1.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 sat 25 minuta',
            value: 85,
        },
        {
            label: '1 sat 20 minuta',
            value: 80,
        },
        {
            label: '1 sat 15 minuta',
            value: 1.25 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 sat 10 minuta',
            value: 70,
        },
        {
            label: '1 sat 5 minuta',
            value: 65,
        },
        {
            label: '1 sat',
            value: 1 * ONE_HOUR_MINUTES,
        },
        {
            label: '55 minuta',
            value: 55,
        },
        {
            label: '50 minuta',
            value: 50,
        },
        {
            label: '45 minuta',
            value: (3 * ONE_HOUR_MINUTES) / 4,
        },
        {
            label: '40 minuta',
            value: (ONE_HOUR_MINUTES * 2) / 3,
        },
        {
            label: '35 minuta',
            value: 35,
        },
        {
            label: '30 minuta',
            value: ONE_HOUR_MINUTES / 2,
        },
        {
            label: '25 minuta',
            value: ONE_HOUR_MINUTES / 2.4,
        },
        {
            label: '20 minuta',
            value: ONE_HOUR_MINUTES / 3,
        },
        {
            label: '15 minuta',
            value: ONE_HOUR_MINUTES / 4,
        },
        {
            label: '10 minuta',
            value: ONE_HOUR_MINUTES / 6,
        },
        {
            label: '5 minuta',
            value: ONE_HOUR_MINUTES / 12,
        },
        {
            label: '0 minuta',
            value: '0',
        },
    ],
    ru: [
        {
            label: '12 часов',
            value: 12 * ONE_HOUR_MINUTES,
        },
        {
            label: '11 часов',
            value: 11 * ONE_HOUR_MINUTES,
        },
        {
            label: '10 часов',
            value: 10 * ONE_HOUR_MINUTES,
        },
        {
            label: '9 часов',
            value: 9 * ONE_HOUR_MINUTES,
        },
        {
            label: '8 часов',
            value: 8 * ONE_HOUR_MINUTES,
        },
        {
            label: '7 часов',
            value: 7 * ONE_HOUR_MINUTES,
        },
        {
            label: '6 часов',
            value: 6 * ONE_HOUR_MINUTES,
        },
        {
            label: '5 часов',
            value: 5 * ONE_HOUR_MINUTES,
        },
        {
            label: '4 часа',
            value: 4 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 часа 30 минут',
            value: 3.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 часа',
            value: 3 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 часа 45 минут',
            value: 2.75 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 часа 30 минут',
            value: 2.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 часа 15 минут',
            value: 2.25 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 часа',
            value: 2 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 час 55 минут',
            value: 115,
        },
        {
            label: '1 час 50 минут',
            value: 110,
        },
        {
            label: '1 час 45 минут',
            value: 1.75 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 час 40 минут',
            value: 100,
        },
        {
            label: '1 час 35 минут',
            value: 95,
        },
        {
            label: '1 час 30 минут',
            value: 1.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 час 25 минут',
            value: 85,
        },
        {
            label: '1 час 20 минут',
            value: 80,
        },
        {
            label: '1 час 15 минут',
            value: 1.25 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 час 10 минут',
            value: 70,
        },
        {
            label: '1 час 5 минут',
            value: 65,
        },
        {
            label: '1 час',
            value: 1 * ONE_HOUR_MINUTES,
        },
        {
            label: '55 минут',
            value: 55,
        },
        {
            label: '50 минут',
            value: 50,
        },
        {
            label: '45 минут',
            value: (3 * ONE_HOUR_MINUTES) / 4,
        },
        {
            label: '40 минут',
            value: (ONE_HOUR_MINUTES * 2) / 3,
        },
        {
            label: '35 минут',
            value: 35,
        },
        {
            label: '30 минут',
            value: ONE_HOUR_MINUTES / 2,
        },
        {
            label: '25 минут',
            value: ONE_HOUR_MINUTES / 2.4,
        },
        {
            label: '20 минут',
            value: ONE_HOUR_MINUTES / 3,
        },
        {
            label: '15 минут',
            value: ONE_HOUR_MINUTES / 4,
        },
        {
            label: '10 минут',
            value: ONE_HOUR_MINUTES / 6,
        },
        {
            label: '5 минут',
            value: ONE_HOUR_MINUTES / 12,
        },
        {
            label: '0 минут',
            value: '0',
        },
    ],
    bih: [
        {
            label: '12 sati',
            value: 12 * ONE_HOUR_MINUTES,
        },
        {
            label: '11 sati',
            value: 11 * ONE_HOUR_MINUTES,
        },
        {
            label: '10 sati',
            value: 10 * ONE_HOUR_MINUTES,
        },
        {
            label: '9 sati',
            value: 9 * ONE_HOUR_MINUTES,
        },
        {
            label: '8 sati',
            value: 8 * ONE_HOUR_MINUTES,
        },
        {
            label: '7 sati',
            value: 7 * ONE_HOUR_MINUTES,
        },
        {
            label: '6 sati',
            value: 6 * ONE_HOUR_MINUTES,
        },
        {
            label: '5 sati',
            value: 5 * ONE_HOUR_MINUTES,
        },
        {
            label: '4 sata',
            value: 4 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 sata 30 minuta',
            value: 3.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '3 sata',
            value: 3 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 sata 45 minuta',
            value: 2.75 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 sat 30 minuta',
            value: 2.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 sat 15 minuta',
            value: 2.25 * ONE_HOUR_MINUTES,
        },
        {
            label: '2 sata',
            value: 2 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 sat 55 minuta',
            value: 115,
        },
        {
            label: '1 sat 50 minuta',
            value: 110,
        },
        {
            label: '1 sat 45 minuta',
            value: 1.75 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 sat 40 minuta',
            value: 100,
        },
        {
            label: '1 sat 35 minuta',
            value: 95,
        },
        {
            label: '1 sat 30 minuta',
            value: 1.5 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 sat 25 minuta',
            value: 85,
        },
        {
            label: '1 sat 20 minuta',
            value: 80,
        },
        {
            label: '1 sat 15 minuta',
            value: 1.25 * ONE_HOUR_MINUTES,
        },
        {
            label: '1 sat 10 minuta',
            value: 70,
        },
        {
            label: '1 sat 5 minuta',
            value: 65,
        },
        {
            label: '1 sat',
            value: 1 * ONE_HOUR_MINUTES,
        },
        {
            label: '55 minuta',
            value: 55,
        },
        {
            label: '50 minuta',
            value: 50,
        },
        {
            label: '45 minuta',
            value: (3 * ONE_HOUR_MINUTES) / 4,
        },
        {
            label: '40 minuta',
            value: (ONE_HOUR_MINUTES * 2) / 3,
        },
        {
            label: '35 minuta',
            value: 35,
        },
        {
            label: '30 minuta',
            value: ONE_HOUR_MINUTES / 2,
        },
        {
            label: '25 minuta',
            value: ONE_HOUR_MINUTES / 2.4,
        },
        {
            label: '20 minuta',
            value: ONE_HOUR_MINUTES / 3,
        },
        {
            label: '15 minuta',
            value: ONE_HOUR_MINUTES / 4,
        },
        {
            label: '10 minuta',
            value: ONE_HOUR_MINUTES / 6,
        },
        {
            label: '5 minuta',
            value: ONE_HOUR_MINUTES / 12,
        },
        {
            label: '0 minuta',
            value: '0',
        },
    ],
})
